import React, { Component } from 'react'
import './index.less'
import langM from './lang'
import {
  inject,
  observer,
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  forbidScroll,
  throttle
} from 'src/helper/devTools.js'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'
import localstorage from 'src/helper/localstorage'
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'
import LoadingComp from 'src/component/LoadingComp'
import http from 'src/helper/http'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.rechargeStore = this.props.store.register('app/recharge')
    setDocumentTitle('Recharge')
    this.handleLang = throttle(this.handleLang, 1000)
  }
  state = {
    lang: langM.ar,
    payState: 0,
    payItemState: 1,
    isNationMore: false,
    priceIndex: -1,
    isLang: false,
    isLangShow: false,
  
    // 是否选择policy
    isPolicy: true,

    // 是否查询到该用户
    searchUser: false,
    noFoundUser: false,
    noNull: false,

    // 国家
    hosList: [],
    allList: [],

    // 语言适配
    langObj: {},
    langState: 0,

    // 输入框
    inputValue: '',

    price: '',
    SAR: '',

    // 轮播图列表
    bannerList: [
      {
        img: '/img/app/recharge/banner/bg1.png',
        url: window.location.origin + `/#/app/refund`
      }
    ],
    language:'en',
    payList: [],
    selNationName: '',
    userInfo: {},
    priceList: [],
    sendGold: 0,
    sendPrice: 0,
    mapList: [],
    payId: 1,
    identifier:'',
    desc: '',
    initShow: true,
    newUrl:'',
    watchClickTimeId:null,
  }

  async initLang() {
    let { language } = this.props.location.location.query

    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.location.query)
    if (!uid) {
      uid = localstorage.get('userInfo').uid
    }
    return uid
  }

  initLangObj() {
    if (this.state.language == 'zh') {
      this.setState({
        langObj: langM.zh,
        langState: 1
      })
    }
    if (this.state.language == 'en') {
      this.setState({
        langObj: langM.en,
        langState: 2
      })
    }
    if (this.state.language == 'ar') {
      this.setState({
        langObj: langM.ar,
        langState: 3
      })
    }
    if (this.state.language == 'tr') {
      this.setState({
        langObj: langM.tr,
        langState: 4
      })
    }
  }

  initSwiper() {
    // 分页器
    const mySwiper = new Swiper('.swiper', {
      slidesPerView: 1
    })
    this.setState({
      mySwiper
    })
  }

  async initNationList() {
    try {
      let { type } = this.props
      // 国家选择列表
      let nation = await this.rechargeStore.getNationList()
      // 默认国家支付方法列表
      let payList = await this.rechargeStore.newPayList((nation && nation.default.countryId) || 17, type == 'ruby' ? 1 : null)
      await this.setState({
        hosList: nation && nation.hot,
        allList: nation && nation.all,
        payList: payList,
        selNationName: (nation && nation.default.countryName) || 'KSA',
        payState:1,
        priceList:(localstorage.get('paypalType') == 1 ||localstorage.get('paypalType') == 2 )? payList[1].list:payList[0].list,
      })
      let isRuby  = localstorage.get('isRuby')
      if (isRuby && isRuby>0) {
        this.refs.msg.show(this.state.lang.successful)
      }
      if (localstorage.get('paypalType') == 1 ||localstorage.get('paypalType') == 2) {
        let a = localstorage.get('payIndex')
        this.setState({
          payId:999,
          payState:2,
        })
      }
      localstorage.remove('isRuby')
      localstorage.remove('paypalType')
      localstorage.remove('payIndex')
      localstorage.remove('whatRecharge')
    } catch (error) {
      this.refs.msg.show('error')
      console.error(error)
      return new Error(error)
    }
  }

  async componentWillMount() {
    this.initLang()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
    this.setState({ userInfo: { uid } })
    let isRuby  = localstorage.get('isRuby')
  }
  ew = null
  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    this.setState({
      uid: uid
    })
    await this.rechargeStore.GetUserInfoWeb(uid)
    this.initLangObj()
    this.initSwiper()
    this.initNationList()

    this.setState({
      initShow: false
    })
  }
  mapTxt(v) {
    return new Map([
      ['eId', this.state.langObj.eId],
      ['eNation', this.state.langObj.eNation],
      ['ePayMethods', this.state.langObj.ePayMethods],
      ['eRechargeGold', this.state.langObj.eRechargeGold],
      ['ePolicy', this.state.langObj.ePolicy]
    ]).get(v)
  }

  /**
   * @description 选择国家
   */
  handleNationSel(state) {
    forbidScroll(state)
    this.setState({
      isNationMore: state
    })
  }

  /**
   * @description 下拉语言动画操作
   */
  handleLang(state) {
    if (!this.state.isLang) {
      this.setState({
        isLangShow: state
      })
      setTimeout(() => {
        this.setState({
          isLang: state
        })
      }, 10)
    } else {
      this.setState({
        isLang: false
      })
      setTimeout(() => {
        this.setState({
          isLangShow: false
        })
      }, 800)
    }
  }

  /**
   * @description 是否选择同意policy
   */
  handlePolicy() {
    this.setState({
      isPolicy: !this.state.isPolicy
    })
  }

  /**
   * @description 切换模式显示
   */
  langModeTxt() {
    if (this.state.langState == 1) {
      return `中文`
    }
    if (this.state.langState == 2) {
      return `English`
    }
    if (this.state.langState == 3) {
      return `بالعربية`
    }
    if (this.state.langState == 4) {
      return `Turkey`
    }
  }

  /**
   * @description 修改语言
   */
  onChangeLang(state) {
    let langMode = {}
    if (state == 1) {
      langMode = langM.zh
    }
    if (state == 2) {
      langMode = langM.en
    }
    if (state == 3) {
      langMode = langM.ar
    }
    if (state == 4) {
      langMode = langM.tr
    }
    this.handleLang(true)
    this.setState({
      langState: state,
      langObj: langMode
    })
  }

  /**
   * @description 输入
   */
  handleInput(e) {
    const val = e.target.value
    this.setState({
      inputValue: val
    })
  }

  /**
   * @description 查找ID
   */
  async onHandleSearch() {
    try {
      if (this.state.inputValue.trim() == '' || this.state.inputValue == '') {
        this.setState({
          noNull: true,
          noFoundUser: false
        })
        return
      }
      let search = await this.rechargeStore.verifyUser(this.state.inputValue)
      if (search && search.code == 1) {
        this.setState({
          noNull: true,
          noFoundUser: false
        })
        return
      }
      if (search == null) {
        this.setState({
          noNull: false,
          noFoundUser: true
        })
        return
      }
      if (search) {
        this.setState({
          userInfo: search,
          searchUser: true,
          noFoundUser: false,
          noNull: false
        })
      }
    } catch (error) {
      this.refs.msg.show('error')
      console.error(error)
      return new Error(error)
    }
  }
  
  checkFn = ()=>{
    if (!(this.state.userInfo && this.state.userInfo.uid)) {
      this.refs.msg.show(this.mapTxt('eId'))
      return
    }
    if (!this.state.selNationName) {
      this.refs.msg.show(this.mapTxt('eNation'))
      return
    }
    if (!this.state.payId) {
      this.refs.msg.show(this.mapTxt('ePayMethods'))
      return
    }
    if (!this.state.identifier) {
      this.refs.msg.show(this.mapTxt('eRechargeGold'))
      return
    }
    if (!this.state.isPolicy) {
      this.refs.msg.show(this.mapTxt('ePolicy'))
      return
    }
  }
  /**
   * @description 充值操作
   */
 
  async onHandleRecharge() {
    try {
      // 过滤前提条件
      if (!(this.state.userInfo && this.state.userInfo.uid)) {
        this.refs.msg.show(this.mapTxt('eId'))
        return
      }
      if (!this.state.selNationName) {
        this.refs.msg.show(this.mapTxt('eNation'))
        return
      }
      if (!this.state.payId) {
        this.refs.msg.show(this.mapTxt('ePayMethods'))
        return
      }
      if (!this.state.identifier) {
        this.refs.msg.show(this.mapTxt('eRechargeGold'))
        return
      }
      if (!this.state.isPolicy) {
        this.refs.msg.show(this.mapTxt('ePolicy'))
        return
      }
      if (this.state.payId == 999) {
        return this.paypalRecharge()
      }
      if (this.state.payId == 888) {
        return  this.razerPayFn()
      }
      // 再次确保前提条件
      const conditions =
        this.state.userInfo &&
        this.state.userInfo.uid &&
        this.state.payId &&
        this.state.identifier &&
        this.state.isPolicy

      if (conditions) {
        let { type } = this.props
        let res = await this.rechargeStore.placeOrder({
          uid: this.state.userInfo && this.state.userInfo.uid,
          identifier: this.state.identifier,
          id: this.state.payId,
          frontCallbackURL: window.location.origin + `/#/app/ruby-agent`,
          rechargeRuby: type == 'ruby' ? 1 : 0
        })
        if (res && res.code != 0) {
          this.refs.msg.show(res && res.msg)
          return
        }
        if (res && res.code == 0) {
          this.setState({
            url: res && res.res && res.res.redirectUrl,
            inputValue: ''
          })
          window.location.href = res && res.res && res.res.redirectUrl
        }
      }
    } catch (error) {
      console.log(error,)
      return
      this.refs.msg.show('error')
      console.error(error)
      return new Error(error)
    }
  }

  /**
   * @description 更新国家名字显示
   * @param nId 国家id
   */
  updateNationName(nId) {
    let name = ''
    this.state.hosList.map((item) => {
      if (item.countryId == nId) {
        name = item.countryName
      }
    })
    this.state.allList.map((item) => {
      if (item.countryId == nId) {
        name = item.countryName
      }
    })
    this.setState({
      selNationName: name
    })
  }

  /**
   * @description 选择国家支付方式
   * @param nId 国家id
   */
  async onHandlePayNationList(nId, type) {
    
    // 取消支付方式的下拉状态
    this.setState({
      payState: 0
    })
    // 没有传递nId
    if (!nId) {
      return
    }
   
    // 关闭选择国家
    this.handleNationSel(false)
    // 请求国家支付方式列表
    let payList = await this.rechargeStore.newPayList(nId, this.props.type == 'ruby' ? 1 : null)
    this.setState({
      payList: payList
    })
    this.setState({
      priceIndex: -1,
      payId: 1,
      identifier: null,
      sendGold: null,
      sendPrice: null,
      payState:1
    })
    // 更新国家名字
    this.updateNationName(nId)
  }

  /**
   * @description 重置查询信息
   */
  onClearId() {
    this.setState({
      searchUser: false,
      userInfo: {},
      priceIndex: -1
    })
  }

  /**
   * @description 跳转到反馈页
   */
  toFeedback() {
    const url = window.location.origin + `/#/app/service/feedback`
    window.location.href = url
  }

  /**
   * @description 充值额度选择组件
   */
  payPriceComp(state) {
    let { type } = this.props
    const handlePrice = async (i, gold, price, identifier) => {
      if (!this.state.userInfo.uid) {
        // 未选择充值ID
        this.refs.msg.show(this.mapTxt('eId'))
        this.setState({
          priceIndex: -1
        })
        return
      }
      this.setState({
        identifier: identifier,
        sendGold: gold,
        sendPrice: price,
        priceIndex: i
      })
    }
    return (
      <div className="official-recharge-pay-main" >
        {this.state.priceList &&
          this.state.priceList.map((item, index) => {
            return (
              <div
                key={index}
                className={`official-recharge-pay-main-item ${this.state.priceIndex == index ? 'official-recharge-pay-main-item-active' : ''
                  }`}
                onClick={() => {
                  handlePrice(index, item.coin, item.price, item.identifier)
                }}
              >
                <div className="gold">
                  {type != 'ruby' && (<img src="/img/app/ruby-agent/big-gold-icon.png" alt="" />)}
                  {type == 'ruby' && (<img src="/img/app/ruby/icon_ruby_56.png" alt="" style={{ width: '0.36rem', height: '0.32rem' }} />)}
                  <span>{item.coin}</span>
                </div>
                <div className="price">
                  {item.price / 100} {item.currency}
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  /**
   * @description 下拉支付方法组件
   */
  payMethodComp(img, txt, state, id) {
    const handleState = async (nid) => {
      // 清空上一次选中数据
      this.setState({
        priceIndex: -1,
        payId: nid,
        identifier: null,
        sendGold: null,
        sendPrice: null,
      })
      // 重复点击的状态
      if (this.state.payState != state) {
        await this.setState({
          priceList: this.state.payList && this.state.payList[state - 1] && this.state.payList[state - 1].list,
          payState: state
        })
      }
    }
    console.log(state, this.state.payState)
    return (
      <div
        className="official-recharge-pay-item"
        onClick={() => {
          handleState(id)
        }}
      >
        <div className="info">
          <div className="icon">
            <img src={img} alt="" className={`${img.includes('pay3') ? 'pic' : ''}`} />
          </div>
          <div className="txt">{txt}</div>
        </div>
        <div className={`more ${this.state.payState == state ? 'more-reverse' : ''}`}>
          {state == this.state.payState && <img src="/img/app/recharge/icon_common_checkmar.png" alt="" />}
        </div>
      </div>
    )
  }


  showGoldModle = (open, close) => {
    let { sendPrice, sendGold, lang, payId } = this.state
    let { type, degold, addNum } = this.props
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.checkText}</div>
        <div className="gold-modle-body">
          <div className="amount">
            <div className="amout-left">{lang.rechargeAmountText}</div>
            <div className="amout-rigit">${sendPrice / 100}</div>
          </div>
          <div className="amount">
            {type == 'ruby' && <div className="amout-left">{lang.getRubiesText}</div>}
            {type != 'ruby' && <div className="amout-left">{lang.getCoinsText}</div>}
            <div className="amout-rigit">{sendGold}</div>
          </div>
          <div className="amount">
            <div className="amout-left">{lang.total}</div>
            {degold>0 && <div className="amout-rigit">{-(degold-sendGold)}</div>}
            {degold == 0 && <div className="amout-rigit">{(sendGold+addNum)}</div>}
          </div>
        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.cancel}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.onHandleRecharge()}
          >
            {lang.recharge}
          </div>
        </div>
      </div>
    )
  }

  /**
   * @description 充值和policy组件
   */
  policyComp() {
    return (
      <div className="official-recharge-policy">
        <div
          className="official-recharge-pay-btn"
          onClick={() => {
            this.onHandleRecharge()
          }}
        >
          {this.state.langObj.r}
        </div>
        <div
          className="official-recharge-pay-privacy"
          onClick={() => {
            this.handlePolicy()
          }}
        >
          <div className={`circle ${this.state.isPolicy ? 'circle-active' : ''}`}></div>
          <div className="txt">{this.state.langObj.policy}</div>
        </div>
        <div className="official-recharge-pay-help">
          <div
            className="help1"
            onClick={() => {
              this.toFeedback()
            }}
          >
            {this.state.langObj.help}
          </div>
          {/* <div className="help2">Device trust</div> */}
        </div>
      </div>
    )
  }

  /**
   * @description 国家选择展示组件
   */
  nationSelComp() {
    return (
      <div
        className="official-recharge-nation-sel"
        style={{ transform: `translateY(${this.state.isNationMore ? '0' : '99.9vh'})` }}
      >
        <div className="official-recharge-nation-sel-wrap">
          <div className="hot-main">
            <div className="title">
              <span>{this.state.langObj.hot}</span>
              <div
                className="icon"
                onClick={() => {
                  this.handleNationSel(false)
                }}
              ></div>
            </div>
            <div className="content">
              {this.state.hosList &&
                this.state.hosList.map((item, index) => {
                  return (
                    <div
                      className="content-item"
                      key={index}
                      onClick={() => {
                        this.onHandlePayNationList(item.countryId, 'hot')
                      }}
                    >
                      <img src={item.countryIcon} alt="" />
                      <span>{item.countryName}</span>
                    </div>
                  )
                })}
            </div>
          </div>
          <div className="all-main">
            <div className="title">{this.state.langObj.all}</div>
            <div className="content">
              {this.state.allList &&
                this.state.allList.map((item, index) => {
                  return (
                    <div
                      className="content-item"
                      key={index}
                      onClick={() => {
                        this.onHandlePayNationList(item.countryId, 'all')
                      }}
                    >
                      <img src={item.countryIcon} alt="" />
                      <span>{item.countryName}</span>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
   * @description 国家icon模块组件
   */
  selNationComp() {
    return (
      <div
        className="official-recharge-nation"
        onClick={() => {
          this.handleNationSel(true)
        }}
      >
        <div className="nation">
          <div className="icon"></div>
          <div className="txt">
            {this.state.selNationName}
            <span style={{ display: `${this.state.selNationName ? 'none' : 'block'}` }}>
              {this.state.langObj.enterNation}
            </span>
          </div>
        </div>
        <div className="more"></div>
      </div>
    )
  }

  /**
   * @description 头部组件
   */
  headerComp() {
    return (
      <div className="official-recharge-header">
        <div className="official-recharge-header-top">
          <div className="logo"></div>
          <div className="language">
            <div className="icon"></div>
            <div className="txt">
              <span
                onClick={() => {
                  this.handleLang(true)
                }}
              >
                {this.langModeTxt()}
              </span>
              <div
                className="lang-more-content-wrap"
                style={{
                  display: `${this.state.isLangShow && this.state.langState != 3 ? 'block' : 'none'}`
                }}
              >
                <div
                  className="lang-more-content"
                  style={{ transform: `translateY(${this.state.isLang ? '0rem' : '-30vh'})` }}
                >
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(1)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 1 ? 'block' : 'none'}` }}
                    />
                    <span>中文</span>
                  </div>
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(2)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 2 ? 'block' : 'none'}` }}
                    />
                    <span>English</span>
                  </div>
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(3)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 3 ? 'block' : 'none'}` }}
                    />
                    <span>بالعربية</span>
                  </div>
                </div>
              </div>
              <div
                className="lang-more-content-wrap"
                style={{
                  display: `${this.state.langState == 3 ? 'block' : 'none'}`,
                  right: `-2.7rem`
                }}
              >
                <div
                  className="lang-more-content"
                  style={{ transform: `translateY(${this.state.isLang ? '0rem' : '-30vh'})` }}
                >
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(1)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 1 ? 'block' : 'none'}` }}
                    />
                    <span>中文</span>
                  </div>
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(2)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 2 ? 'block' : 'none'}` }}
                    />
                    <span>English</span>
                  </div>
                  <div
                    className="lang-more-content-item"
                    onClick={() => {
                      this.onChangeLang(3)
                    }}
                  >
                    <img
                      src="/img/app/recharge/yes.png"
                      alt=""
                      style={{ display: `${this.state.langState == 3 ? 'block' : 'none'}` }}
                    />
                    <span>بالعربية</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="official-recharge-header-bottom">
          <div className="banner">
            <div className="swiper">
              <div className="swiper-wrapper">
                {this.state.bannerList.map((item, index) => {
                  return (
                    <div className="swiper-slide" key={index}>
                      <a href={item.url}>
                        <img src={item.img} alt="" />
                      </a>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="account">
            <div className="top">
              <span className="title">{this.state.langObj.ra}</span>
              <span
                onClick={() => {
                  this.onClearId()
                }}
                className="other"
                style={{ display: `${this.state.searchUser ? 'block' : 'none'}` }}
              >
                {this.state.langObj.otherId}
              </span>
            </div>
            <div className="center" style={{ display: `${this.state.searchUser ? 'none' : 'flex'}` }}>
              <input
                type="text"
                value={this.state.inputValue}
                placeholder={this.state.langObj.eu}
                onChange={(e) => {
                  e.persist()
                  this.handleInput(e)
                }}
              />
              <div
                className="btn"
                onClick={() => {
                  this.onHandleSearch()
                }}
              >
                {this.state.langObj.search}
              </div>
            </div>
            <div className="center2" style={{ display: `${this.state.searchUser ? 'flex' : 'none'}` }}>
              <img className="pic" src={this.state.userInfo && this.state.userInfo.avatarurl} alt="" />
              <div className="info">
                <div className="name">{this.state.userInfo && this.state.userInfo.nickname}</div>
                <div className="id">ID:{this.state.userInfo && this.state.userInfo.duid}</div>
              </div>
            </div>
            <div className="bottom" style={{ display: `${this.state.noFoundUser ? 'block' : 'none'}` }}>
              <span>{this.state.langObj.noExit}</span>
            </div>
            <div className="bottom" style={{ display: `${this.state.noNull ? 'block' : 'none'}` }}>
              <span>{this.state.langObj.noNull}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  razerPayFn = async()=>{
    this.setState({ showLoding:true })
    let { userInfo, identifier, payId } = this.state
    let res = await http.post('/withoutsign/razer/pay',{
      uid: userInfo && userInfo.uid,
      identifier: identifier,
      id: payId,
      frontCallbackURL: window.location.origin + `/#/app/ruby-agent`
    })
    setTimeout(()=>{
      this.setState({ showLoding:false })
    },2000)
    if (res.code == 0 ) {
      window.location.href = res.res.paymentUrl
    }
  }
  
  paypalRecharge = async()=>{
    this.setState({ showLoding:true })
    let { uid, identifier, watchClickTimeId } = this.state
    http.post('/withoutsign/paypal/order/pay', {
      "uid": uid,
      "Identifier": identifier,
      "id": 1
  }).then((response) => { 
    let a = JSON.parse(response.res.msg);
    let url = a.links[1].href //存储确认订单路径
    //let pons = window.open(url)
    window.location.href = url
    setTimeout(()=>{
      this.setState({ showLoding:false })
    },2000)
    // 
    localstorage.set('paypalType',this.props.type == 'gold'?1:2)
    localstorage.set('payIndex',this.state.priceIndex)
    localstorage.set('whatRecharge',1)
  })
  }
  timeId = null
  paySelComp() {
    return (
      <div className="official-recharge-pay" >
        <div className="official-recharge-pay-wrap">
          {this.state.payList && this.state.payList.length > 0 &&
            this.state.payList.map((item, index) => {
              return (
                <div key={index}>
                  {this.payMethodComp(item.icon, item.method, index + 1, item.id)}
                </div>
              )
            })}
        </div>
      </div>
    )
  }

  render() {
    let { lang } = this.props
    let {
      payState,
      showLoding,
      identifier,
      priceIndex,
      payId
    } = this.state
    console.log(payId,'dsadadad')
    return (
      <div className={`official-recharge-main-wrapper ${this.state.langState == 3 && 'arlang'}`}>
        <LoadingComp show={this.state.initShow} />
        <Message ref="msg" desc={this.state.desc} />
        {/* 头部 */}
        {/* 选择国家 */}
        {this.selNationComp()}
        {this.payPriceComp(payState)}
        {/* 支付选择 */}
        {this.paySelComp()}
        {/* 国家选择模块 */}
        {this.nationSelComp()}
        {/* 确认操作模块 */}
        {priceIndex!= -1 && <ReminderBtn
          lang={this.state.lang}
          slotButtonComp={() => {
            return (<div className="btn-root">
            <div className="appropriate-btn" >{lang.recharge}</div>
          </div>)
          }}
          slotContentComp={this.showGoldModle}
        />}
        {priceIndex==-1 && <div className="btn-root" onClick={this.checkFn}>
            <div className="appropriate-btn" >{lang.recharge}</div>
          </div>
        }
        { <LoadingComp show={showLoding}></LoadingComp>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/Recharges/index.js